import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export enum ActiveOrderPaymentStatus {
  Error,
  Success,
  Idle,
}

export const NON_APPROVAL_ORDER_GROUP = "non-approval-order";

export type ActiveOrderGroup = {
  supplierId: string;
  paymentStatus: ActiveOrderPaymentStatus;
};

type ShoppingSummaryState = {
  activeOrderGroup: ActiveOrderGroup | null;
};
type ShoppingSummaryActions = {
  updateActiveOrderGroup: (
    supplierId: string,
    status: ActiveOrderPaymentStatus
  ) => void;
};
const ShoppingSummaryStateContext = createContext<ShoppingSummaryState | null>(
  null
);

const ShoppingSummaryActionsContext = createContext<ShoppingSummaryActions | null>(
  null
);

export const useShoppingSummaryStateContext = () => {
  const ctx = useContext(ShoppingSummaryStateContext);
  if (!ctx) {
    throw new Error("useShoppingSummaryState must be inside Provider");
  }
  return ctx;
};

export const useShoppingSummaryActionsContext = () => {
  const ctx = useContext(ShoppingSummaryActionsContext);
  if (!ctx) {
    throw new Error("useShoppingSummaryActions must be inside Provider");
  }

  return ctx;
};

export const ShoppingSummaryContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [
    activeOrderGroup,
    setActiveOrderGroup,
  ] = useState<ActiveOrderGroup | null>(null);

  const updateActiveOrderGroup: ShoppingSummaryActions["updateActiveOrderGroup"] = useCallback(
    (supplierId, status) => {
      setActiveOrderGroup({supplierId, paymentStatus: status});
    },
    []
  );
  const actionsValue = useMemo(() => ({updateActiveOrderGroup}), [
    updateActiveOrderGroup,
  ]);
  const stateValue = useMemo(() => ({activeOrderGroup}), [activeOrderGroup]);

  return (
    <ShoppingSummaryStateContext.Provider value={stateValue}>
      <ShoppingSummaryActionsContext.Provider value={actionsValue}>
        {children}
      </ShoppingSummaryActionsContext.Provider>
    </ShoppingSummaryStateContext.Provider>
  );
};
